import { createFileRoute } from "@tanstack/react-router";
import { HowItWorksPage } from "./sa-fungerar-det";

export const Route = createFileRoute("/es/como-funciona")({
  head: () => ({
    meta: [
      { title: "Cómo funciona – de la foto al anuncio publicado | Sellavo" },
      { name: "description", content: "Haz una foto o graba tu objeto y Sellavo escribe el anuncio por ti en segundos." },
      { property: "og:title", content: "Cómo funciona – de la foto al anuncio publicado | Sellavo" },
      { property: "og:description", content: "Haz una foto o graba tu objeto y Sellavo escribe el anuncio por ti en segundos." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/como-funciona" }],
  }),
  component: HowItWorksPage,
});
